import {Image} from 'react-native';

import styled from '../lib/utils/styled';

export const ResponsiveImage = styled(Image)({
  resizeMode: 'contain',
  height: '100%',
});
